"use client";
import React from "react";
import MainLayout from "../components/MainLayout";
import TradeLayout from "../components/layout/Trade/TradeLayout";
import PriceMarketLayout from "../components/layout/PriceMarket/PriceMarketLayout";
import KeyHighlightLayout from "../components/layout/ื์KeyHighlight/KeyHighlightLayout";
import WhatWeOffer from "../components/layout/WhatWeOffers/WhatWeOffer";
import LastestNew from "./test-newsgrid/page";
import FinancialToolstLayout from "../components/layout/FinancialTools/FinancialToolstLayout";
import InformationtLayout from "../components/layout/Information/InformationLayout";
import ActivitiesSection from "@/components/ActivitiesSection";
import CollegeSection from "@/components/CollegeSection";

export default function Home() {
  return (
    <MainLayout>
      {/*TODO:News Section*/}
      <WhatWeOffer />
      <TradeLayout />
      <PriceMarketLayout />
      <LastestNew />
      <ActivitiesSection />
      <CollegeSection />
      <InformationtLayout />
      <KeyHighlightLayout />
      <FinancialToolstLayout />

      {/*TODO:Last Update */}
    </MainLayout>
  );
}
